import React from 'react';
import { gameConfigStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';

export const GameLimitSection = observer(() => {
  const { limits } = gameConfigStore;
  const { currencySymbolOrCode } = userInfoStore;
  const t = useTranslation();

  return (
    <div className='min-max-bet'>
      <p className='min-max-b-row'>
        <span className='min-max-text'>{t('MIN')}</span>
        <span className='min-max-text money'>
          {currencySymbolOrCode} {limits.minBet}
        </span>
      </p>
      <p className='min-max-b-row has-space'>
        <span className='min-max-text'>{t('MAX')}</span>
        <span className='min-max-text money'>
          {currencySymbolOrCode} {limits.maxBet}
        </span>
      </p>
    </div>
  );
});
